<div class="year-range-picker">
    <button *ngFor="let year of years" (click)="selectYear(year)">{{ year }}</button>
</div>